import { render, staticRenderFns } from "./BasicTheme.vue?vue&type=template&id=52b0493a&scoped=true&"
import script from "./BasicTheme.vue?vue&type=script&lang=js&"
export * from "./BasicTheme.vue?vue&type=script&lang=js&"
import style0 from "./BasicTheme.vue?vue&type=style&index=0&id=52b0493a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b0493a",
  null
  
)

export default component.exports